import { render, staticRenderFns } from "./UpLoad.vue?vue&type=template&id=d2064de4&scoped=true&"
import script from "./UpLoad.vue?vue&type=script&lang=js&"
export * from "./UpLoad.vue?vue&type=script&lang=js&"
import style0 from "./UpLoad.vue?vue&type=style&index=0&id=d2064de4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2064de4",
  null
  
)

export default component.exports